import Axios from 'axios';
import Vue from 'vue';
import store from '@/store';
import {baseUrl} from '@/global';
import {getCookieInfo, logout} from '@/util';
import {getCorpId} from '@/store/modules/user';

const errorPrompt = (msg) => {
  const message = Vue.prototype.$Message;
  message && message.error(msg);
};
export const errorMes = {
  403: '无权限操作，请联系企业管理员',
  404: '抱歉，这个页面被大Boss带走了，请先去其他页面看看吧',
  500: '抱歉，我好像迷路了',
  401: '抱歉，请登录',
  default: '抱歉，我好像迷路了',
};
const config = {
  errorMes,
  baseURL: baseUrl,
  timeout: 1000 * 60,
  withCredentials: true,
  interReq: (config) => {
    if (config.isIgnoreToken) {
      return config;
    }
    const corpId = getCorpId();
    if (corpId) config.headers.corpId = corpId;
    const {token} = getCookieInfo();
    if (token) config.headers.Authorization = `bearer ${token}`;
    if (store.getters['system/deviceId']) config.headers.deviceId = store.getters['system/deviceId'];
    return config;
  },
  interRes: (res) => {
    const data = res.data;
    const result = (res.data || {}).result !== false;
    if (!result) {
      const errorMes = (res.data || {}).resultDesc || config.errorMes.default;
      errorPrompt(errorMes);
      return Promise.reject(res);
    }
    return Promise.resolve(data);
  },
};

const service = Axios.create(config);
service.interceptors.request.use(config.interReq, (error) => Promise.reject(error));
service.interceptors.response.use(config.interRes, (res) => {
  if (res.response && res.response.status === 401) logout();
  return Promise.reject(res);
});

export default service;
